var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fieldset", [
    _c("legend", [_vm._v(_vm._s(_vm.t("app-program-vetting")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-screens-mentors",
            label: _vm.t("app-program-screens-mentors"),
            options: _vm.optionsYesNoNotApplicable,
          },
          model: {
            value: _vm.program.attributes.programScreensMentors,
            callback: function ($$v) {
              _vm.$set(_vm.program.attributes, "programScreensMentors", $$v)
            },
            expression: "program.attributes.programScreensMentors",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.programScreensMentors === "yes"
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("checkboxes", {
              attrs: {
                label: _vm.t("app-program-screens-mentors-how"),
                options: _vm.optionsScreensMentorsHow,
                cols: 2,
              },
              model: {
                value: _vm.program.attributes.programScreensMentorsHow,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programScreensMentorsHow",
                    $$v
                  )
                },
                expression: "program.attributes.programScreensMentorsHow",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-screens-mentees",
            label: _vm.t("app-program-screens-mentees"),
            options: _vm.optionsYesNoNotApplicable,
          },
          model: {
            value: _vm.program.attributes.programScreensMentees,
            callback: function ($$v) {
              _vm.$set(_vm.program.attributes, "programScreensMentees", $$v)
            },
            expression: "program.attributes.programScreensMentees",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.programScreensMentees === "yes"
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("checkboxes", {
              attrs: {
                label: _vm.t("app-program-screens-mentees-how"),
                options: _vm.optionsScreensMenteesHow,
                cols: 2,
              },
              model: {
                value: _vm.program.attributes.programScreensMenteesHow,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programScreensMenteesHow",
                    $$v
                  )
                },
                expression: "program.attributes.programScreensMenteesHow",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-provides-pre-match-training-to-mentors",
            label: _vm.t("app-program-provides-pre-match-training-to-mentors"),
            options: _vm.optionsYesNoNotApplicable,
          },
          model: {
            value:
              _vm.program.attributes.programProvidesPreMatchTrainingToMentors,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programProvidesPreMatchTrainingToMentors",
                $$v
              )
            },
            expression:
              "program.attributes.programProvidesPreMatchTrainingToMentors",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.programProvidesPreMatchTrainingToMentors === "yes"
      ? _c(
          "div",
          { staticClass: "ui-form-row col-2" },
          [
            _c("checkboxes", {
              attrs: {
                label: _vm.t(
                  "app-program-provides-pre-match-training-to-mentors-how"
                ),
                options:
                  _vm.optionsProvidesPreMatchTrainingToMentorsDeliveredHow,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programProvidesPreMatchTrainingToMentorsDeliveredHow,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programProvidesPreMatchTrainingToMentorsDeliveredHow",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programProvidesPreMatchTrainingToMentorsDeliveredHow",
              },
            }),
            _vm._v(" "),
            _c("app-radios", {
              attrs: {
                name: "program-provides-pre-match-training-to-mentors-mandatory",
                label: _vm.t(
                  "app-program-provides-pre-match-training-to-mentors-mandatory"
                ),
                options: _vm.optionsYesOrNo,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programProvidesPreMatchTrainingToMentorsMandatory,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programProvidesPreMatchTrainingToMentorsMandatory",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programProvidesPreMatchTrainingToMentorsMandatory",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-provides-pre-match-training-to-mentees",
            label: _vm.t("app-program-provides-pre-match-training-to-mentees"),
            options: _vm.optionsYesNoNotApplicable,
          },
          model: {
            value:
              _vm.program.attributes.programProvidesPreMatchTrainingToMentees,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programProvidesPreMatchTrainingToMentees",
                $$v
              )
            },
            expression:
              "program.attributes.programProvidesPreMatchTrainingToMentees",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.programProvidesPreMatchTrainingToMentees === "yes"
      ? _c(
          "div",
          { staticClass: "ui-form-row col-2" },
          [
            _c("checkboxes", {
              attrs: {
                label: _vm.t(
                  "app-program-provides-pre-match-training-to-mentees-how"
                ),
                options:
                  _vm.optionsProvidesPreMatchTrainingToMenteesDeliveredHow,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programProvidesPreMatchTrainingToMenteesDeliveredHow,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programProvidesPreMatchTrainingToMenteesDeliveredHow",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programProvidesPreMatchTrainingToMenteesDeliveredHow",
              },
            }),
            _vm._v(" "),
            _vm.program.attributes.programProvidesPreMatchTrainingToMentees ===
            "yes"
              ? _c("app-radios", {
                  attrs: {
                    name: "program-provides-pre-match-training-to-mentees-mandatory",
                    label: _vm.t(
                      "app-program-provides-pre-match-training-to-mentees-mandatory"
                    ),
                    options: _vm.optionsYesOrNo,
                  },
                  model: {
                    value:
                      _vm.program.attributes
                        .programProvidesPreMatchTrainingToMenteesMandatory,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.program.attributes,
                        "programProvidesPreMatchTrainingToMenteesMandatory",
                        $$v
                      )
                    },
                    expression:
                      "program.attributes.programProvidesPreMatchTrainingToMenteesMandatory",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("checkboxes", {
          attrs: {
            label: _vm.t(
              "app-program-how-does-your-program-match-mentors-to-mentees"
            ),
            options: _vm.optionsHowDoesYourProgramMatchMentorsToMentees,
            cols: 2,
          },
          model: {
            value:
              _vm.program.attributes
                .programHowDoesYourProgramMatchMentorsToMentees,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programHowDoesYourProgramMatchMentorsToMentees",
                $$v
              )
            },
            expression:
              "program.attributes.programHowDoesYourProgramMatchMentorsToMentees",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.programHowDoesYourProgramMatchMentorsToMentees.findIndex(
      (row) => row.value === "other"
    ) !== -1
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("app-input", {
              attrs: {
                type: "text",
                label: _vm.t("app-no-formal-matching-please-explain"),
                required: true,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programHowDoesYourProgramMatchMentorsToMenteesExplainHow,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programHowDoesYourProgramMatchMentorsToMenteesExplainHow",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programHowDoesYourProgramMatchMentorsToMenteesExplainHow",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-does-your-program-provide-ongoing-monitoring-and-support-to-the-mentoring-relationship",
            label: _vm.t(
              "app-does-your-program-provide-ongoing-monitoring-and-support-to-the-mentoring-relationship"
            ),
            options: _vm.optionsYesNoNotApplicable,
          },
          model: {
            value:
              _vm.program.attributes
                .programDoesYourProgramProvideOngoingMonitoringAndSupportToTheMentoringRelationship,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programDoesYourProgramProvideOngoingMonitoringAndSupportToTheMentoringRelationship",
                $$v
              )
            },
            expression:
              "program.attributes.programDoesYourProgramProvideOngoingMonitoringAndSupportToTheMentoringRelationship",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-is-there-a-formal-beginning-and-end-to-the-mentoring-relationship",
            label: _vm.t(
              "app-is-there-a-formal-beginning-and-end-to-the-mentoring-relationship"
            ),
            options: _vm.optionsYesNoNotApplicable,
          },
          model: {
            value:
              _vm.program.attributes
                .programIsThereAFormalBeginningAndEndToTheMentoringRelationship,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programIsThereAFormalBeginningAndEndToTheMentoringRelationship",
                $$v
              )
            },
            expression:
              "program.attributes.programIsThereAFormalBeginningAndEndToTheMentoringRelationship",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-does-your-program-have-specific-goals-or-outcomes",
            label: _vm.t(
              "app-does-your-program-have-specific-goals-or-outcomes"
            ),
            options: _vm.optionsYesNoNotApplicable,
          },
          model: {
            value:
              _vm.program.attributes
                .programDoesYourProgramHaveSpecificGoalsOrOutcomes,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programDoesYourProgramHaveSpecificGoalsOrOutcomes",
                $$v
              )
            },
            expression:
              "program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomes",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomes ===
    "yes"
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("checkboxes", {
              attrs: {
                label: _vm.t(
                  "app-does-your-program-have-specific-goals-or-outcomes-which"
                ),
                options:
                  _vm.optionsDoesYourProgramHaveSpecificGoalsOrOutcomesWhich,
                cols: 3,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programDoesYourProgramHaveSpecificGoalsOrOutcomesWhich,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programDoesYourProgramHaveSpecificGoalsOrOutcomesWhich",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomesWhich",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomes ===
      "yes" &&
    _vm.program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomesWhich.findIndex(
      (row) => row.value === "other"
    ) !== -1
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("app-input", {
              attrs: {
                type: "text",
                label: _vm.t(
                  "app-does-your-program-have-specific-goals-or-outcomes-which-other"
                ),
                required: true,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programDoesYourProgramHaveSpecificGoalsOrOutcomesWhichOther,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programDoesYourProgramHaveSpecificGoalsOrOutcomesWhichOther",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programDoesYourProgramHaveSpecificGoalsOrOutcomesWhichOther",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "ui-form-row" }, [
      _c(
        "fieldset",
        [
          _c("legend", [_vm._v(_vm._s(_vm.t("app-feedback-legend")))]),
          _vm._v(" "),
          _c("app-textarea", {
            attrs: {
              label: _vm.t("app-feedback-label"),
              id: "program-feedback",
            },
            model: {
              value: _vm.program.attributes.feedback,
              callback: function ($$v) {
                _vm.$set(_vm.program.attributes, "feedback", $$v)
              },
              expression: "program.attributes.feedback",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }